// ANGULAR
import { Injectable } from '@angular/core';

// NGRX
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';

// RXJS
import { Observable, of } from 'rxjs';
import { catchError, mergeMap, switchMap, withLatestFrom } from 'rxjs/operators';

// SERVICES
import { FormService } from '../services/form.service';

// ACTIONS AND STATES
import * as globalActions from '../../../global/store/actions';
import { State } from '../../../root-state';
import * as formActions from './actions';

// COMMON INTERFACES AND ENUMS
import { ModalType } from '../../../../models/common/modal/modal-config';

// CONSTANT
import {  FORM_METHOD_CONSTANT, FORM_NGRX_CONSTANTS } from '../../../../constants/ngrx-store/form';


/**
 * This effect is for listen form actions, execute form service call and dispatch in form reducer.
 * For form api call purpose.
 *
 * @author Vikas Thakkar <vikas.thakkar@saeculumsolutions.com>
 *
 * Notes:-
 * Date: 28-05-2020(Vikas Thakkar <vikas.thakkar@saeculumsolutions.com>)  created form effect
 */
@Injectable()
export class FormEffects {
  constructor(
    private actions$: Actions,
    private store: Store<State>,
    private formService: FormService) { }

    /**
			* Form Effect
			* @param type : Form action name.
			* @param payload : object to identify common form method base on module and method.
			* @returns Empty action dispatch to reducer.
			*/
  formCommonEffect$ = createEffect(() => this.actions$.pipe(
    ofType<formActions.FormCommonAction>(formActions.ActionTypes.FORM_COMMON),
    withLatestFrom(this.store),
    mergeMap(([action, state]): Observable<any> => {
      // get common constant base action module and method.
      // changed to payload type from payload.data.method
      const common = FORM_NGRX_CONSTANTS[action.payload.module][action.payload.method];

      // Only sending payload data

      return this.formService[common.API_METHOD](action.payload.data)
        .pipe(

          mergeMap((data: any) => {
            // throwing an error on if the status is not 200

            let actions: any[] = [];


            // dispatch form success action
            actions = [new formActions.FormCommonSuccessAction({ data, common })];

            if (common.SUCCESS_NOTIFICATION) {
              // dispatch popup notification for open success popup
              actions.push(new globalActions.PopupNotificationAction({
                actionType: formActions.ActionTypes.FORM_COMMON, type: ModalType.SUCCESS,
                callback: action.payload.callback, title: common.TITLE, message: common.SUCCESS,
                code: `${common.SUCCESS}`, response: data,
              }));
            } else {
              // tslint:disable-next-line:no-unused-expression
              action.payload.callback && action.payload.callback({ success: true, data });
            }

            return actions;
          }),
          catchError(error => {
            // dispatch popup notification for open error popup
            return of(new globalActions.PopupNotificationAction({
              actionType: formActions.ActionTypes.FORM_COMMON_SUCCESS, type: ModalType.ERROR,
              message: error && error.error && error.error.message, callback: action.payload.callback, error: (error || error.error),
              // code: `ERROR.${error.code || error.error.code}`,
              title: common.TITLE,
            }));
          },
          ));
    }),
  ));

}
